"use client"

import { useEffect, useRef } from "react"
import styled from "styled-components"

const TickerContainer = styled.div`
  height: 48px;
  overflow: hidden;
`

function TickerTape({ isDarkMode }) {
  const containerRef = useRef(null)

  useEffect(() => {
    const script = document.createElement("script")
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js"
    script.async = true
    script.innerHTML = JSON.stringify({
      symbols: [
        {
          proName: "BITSTAMP:BTCUSD",
          title: "Bitcoin",
        },
        {
          proName: "BITSTAMP:ETHUSD",
          title: "Ethereum",
        },
        {
          proName: "BINANCE:BNBUSDT",
          title: "Binance Coin",
        },
        {
          proName: "BINANCE:XRPUSDT",
          title: "Ripple",
        },
        {
          proName: "BINANCE:ADAUSDT",
          title: "Cardano",
        },
        {
          proName: "BINANCE:SOLUSDT",
          title: "Solana",
        },
        {
          proName: "BINANCE:DOGEUSDT",
          title: "Dogecoin",
        },
      ],
      showSymbolLogo: true,
      colorTheme: isDarkMode ? "dark" : "light",
      isTransparent: true,
      displayMode: "adaptive",
      locale: "en",
    })

    if (containerRef.current) {
      containerRef.current.appendChild(script)
    }

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script)
      }
    }
  }, [isDarkMode])

  return (
    <TickerContainer className="tradingview-widget-container" ref={containerRef}>
      <div className="tradingview-widget-container__widget"></div>
    </TickerContainer>
  )
}

export default TickerTape

